<script>
export default {
    props: {
        blocked: {
            type: Boolean,
            require: true,
        },
        activated: {
            type: Boolean,
            require: true,
        },
    },
    data() {
        return {
            dataBlocked: this.blocked,
            dataActivated: this.activated,
        };
    },
    watch: {
        dataBlocked(value) {
            if (value) {
                this.dataActivated = false;
            }
        },
        dataActivated(value) {
            if (value) {
                this.dataBlocked = false;
            }
        }
    },
};
</script>